import React from 'react';
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from "react-redux";

import {addNewWizardItem, saveWizardList, setWizardList} from "./wizardActions";
import WizardSetupTopVisualizerSelect from "./WizardSetupTopVisualizerSelect";
import WizardSetupTopButtonsCloneButton from "./WizardSetupTopButtonsCloneButton";
import {setQuestionPopupState} from "../../actions/A_Popups";
import WizardSetupTopButtonsCopyButton from "./WizardSetupTopButtonsCopyButton";


const WizardSetupTopButtons = (props) => {

  const {wizardList, setWizardList, wizardListReceived, fabricatorSubscriptions, wizardVisualizer, addNewWizardItem,
    setQuestionPopupState, intl, saveWizardList} = props;

  const changeEnabledClick = (selected) => {
    setWizardList(wizardList.map(wizardItem => {
      if (wizardItem.visualizer === wizardVisualizer) {
        wizardItem.selected = selected;
      }
      return Object.assign({}, wizardItem)
    }))
  }

  const addButtonDisabled = !fabricatorSubscriptions.length;

  const currentWizardList = wizardList.filter(wizardItem => wizardItem.visualizer === wizardVisualizer);
  const allSelected = wizardListReceived && currentWizardList.length && currentWizardList.every(wizardItem => wizardItem.selected);
  // const allDisabled = wizardListReceived && currentWizardList.length && currentWizardList.every(wizardItem => !wizardItem.enabled);

  const selectedWizardGroups = currentWizardList.filter(wizardItem => wizardItem.selected);

  // const disableSelectedClick = () => {
  //   if (!selectedWizardGroups.length) {
  //     return false
  //   }
  //   setWizardList(wizardList.map(wizardItem => {
  //     if ((wizardItem.visualizer === wizardVisualizer) && wizardItem.selected) {
  //       wizardItem.enabled = false;
  //     }
  //     return Object.assign({}, wizardItem)
  //   }))
  // }

  const deleteApply = async () => {
    const newWizardList = wizardList
      .map(wizardItem => (wizardItem.visualizer === wizardVisualizer) && wizardItem.selected ? null : wizardItem)
      .filter(wizardItem => wizardItem);
    await saveWizardList(newWizardList);
    setWizardList(newWizardList)
  }

  const deleteSelectedClick = () => {
    if (!selectedWizardGroups.length) {
      return false
    }
    setQuestionPopupState({
      showPopup: true,
      questionMessage: intl.formatMessage({id: "wizard.deleteQuestion"}),
      yesClick: deleteApply,
      noClick: null
    })
  }

  return (
    <div className="wizard-top">
      <div className="wizard-top__left">
        <WizardSetupTopVisualizerSelect/>
        <button className={"ui-button5 ui-button5--green ui-button5--add" + (addButtonDisabled ? " ui-button5--disabled" : "")}
                disabled={addButtonDisabled}
                onClick={addNewWizardItem}>
          <span className="ui-button-icon ui-button-icon--add"/>
          <FormattedMessage id="wizard.newWizardButton"/>
        </button>
      </div>
      <div className="wizard-top__right">
        <button className={"ui-button--add ui-button5 ui-button5--gray ui-button5--145"
          + (allSelected ? " ui-button5--deselect-all" : " ui-button5--select-all")}
                onClick={() => changeEnabledClick(!allSelected)}>
          <span className="ui-button-icon ui-button-icon--grid"/>
          <FormattedMessage id={allSelected ? "wizard.deselectAllButton" : "wizard.selectAllButton"}/>
        </button>
        <WizardSetupTopButtonsCopyButton/>
        <WizardSetupTopButtonsCloneButton/>
        {/*<button className={"ui-button--add ui-button5 ui-button5--gray ui-button5--with-icon"*/}
        {/*  + (!selectedWizardGroups.length || allDisabled ? " ui-button5--disabled" : "")}*/}
        {/*        onClick={disableSelectedClick}>*/}
        {/*  <span className="ui-button-icon ui-button-icon--disable"/>*/}
        {/*  <FormattedMessage id="wizard.groups.disableSelected"/>*/}
        {/*</button>*/}
        <button className={"ui-button--add ui-button5 ui-button5--gray ui-button5--with-icon"
          + (!selectedWizardGroups.length ? " ui-button5--disabled" : "")}
                onClick={deleteSelectedClick}>
          <span className="ui-button-icon ui-button-icon--delete"/>
          <FormattedMessage id="wizard.groups.deleteSelected"/>
        </button>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardList, wizardListReceived, wizardVisualizer} = store.wizardState;
  const {fabricatorSubscriptions} = store.newScope;

  return {
    wizardList,
    wizardListReceived,
    fabricatorSubscriptions,
    wizardVisualizer
  };
};

const mapDispatchToProps = {
  setWizardList,
  addNewWizardItem,
  setQuestionPopupState,
  saveWizardList,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(WizardSetupTopButtons)
)
